import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from "react-redux";
import { verifyInstagramAccount, clearVerifyInstagramAccount } from 'redux/image-sliders/actions';

import { Dimmer, Loader, Segment } from 'semantic-ui-react';

import Button from 'components/elements/buttons/Button';
import CommonInputField from 'components/elements/inputs/CommonInputField';
import CommonMessage from 'components/common/CommonMessage';

import './InstagramSliderNotVerified.scss';

function InstagramSliderNotVerified(props) {
  const {
    item,
    verifyInstagramAccount,
    clearVerifyInstagramAccount,
    verifyInstagramAccountError,
  } = props;

  const [currentValue, setCurrentValue] = useState(null);
  const [verificationInProgress, setVerificationInProgress] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    if (verifyInstagramAccountError) {
      setVerificationInProgress(false);
    }
  }, [verifyInstagramAccountError]);

  const onVerify = () => {
    verifyInstagramAccount(item.id, currentValue);
    setCurrentValue(null);
    setVerificationInProgress(true);
    if (verifyInstagramAccountError) {
      clearVerifyInstagramAccount();
    }
  };

  return (
    <div className="instagram-slider-not-verified__component">
      <div className="text">
        <div>{t('Oooops! Not Verified!')}</div>
        <div>
          {t('Add a link to Heylink.me page to your')}&nbsp;
          <a href="https://instagram.com" target="_blank" rel="noreferrer">Instagram</a>
          &nbsp;{t('Account and try again')}
        </div>
      </div>

      {/* Verification Form */}
      <Segment>
        <div className="verification-form">
          <div className="field-wrapper">
            <CommonInputField
              editIcon
              placeholder="@your_instagram_profile"
              onChange={value => setCurrentValue(value)}
              executedFunction={() => {}}
            />
          </div>
          <Button
            small
            onClick={onVerify}
            disabled={!currentValue}
          >
            {t('Verify Instagram Profile')}
          </Button>
        </div>

        <Dimmer active={verificationInProgress}>
          <Loader>{t('Please, wait... Verification is in progress.')}</Loader>
        </Dimmer>
      </Segment>

      {/* Error */}
      {verifyInstagramAccountError &&
        <CommonMessage
          error
          errors={verifyInstagramAccountError}
        />
      }

    </div>
  );
}

InstagramSliderNotVerified.propTypes = {
  verifyInstagramAccount: PropTypes.func.isRequired,
  clearVerifyInstagramAccount: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  verifyInstagramAccountError: PropTypes.object,
};

InstagramSliderNotVerified.defaultProps = {
  verifyInstagramAccountError: null,
};

const mapStateToProps = state => (
  {
    verifyInstagramAccountError: state.imageSlidersReducer.verifyInstagramAccountError,
  }
);

export default connect(
  mapStateToProps,
  {
    verifyInstagramAccount,
    clearVerifyInstagramAccount,
  },
)(InstagramSliderNotVerified);
